import { Account } from "data/interfaces";
import { createContext, useContext, useState } from "react";

interface AppState {
  accounts: Account[];
  activeAccount?: Account;
}

interface AppContextValue {
  state: AppState;
  setState: (state: AppState) => void;
}

const AppContext = createContext<AppContextValue | undefined>(undefined);

export function AppContextProvider(
  props: React.PropsWithChildren<{}>
): JSX.Element {
  const [state, setState] = useState<AppState>({
    accounts: [],
  });

  return (
    <AppContext.Provider value={{ state, setState }}>
      {props.children}
    </AppContext.Provider>
  );
}

export function useAppContext(): AppContextValue {
  const appContext = useContext(AppContext);
  if (appContext === undefined) {
    throw new Error("AppContext has not been set.");
  } else {
    return appContext;
  }
}
